export const widgetDefault = {
  background: '#FFFFFF',
  text: '#000000',
  button: '#2C3D91',
  buttonHover: '#4982B8',
}

export const productTaxonomyDisplayOptions = {
  all: 'all',
  included: 'included',
  excluded: 'excluded',
}

export const productTaxonomyTypeOptions = {
  category: 'category',
  collection: 'collection',
  tag: 'tag',
}
